import React from 'react';
import BaseTable from '../tables/BaseTable';
import formatters from '../../../utils/forms/formatters';

export default class AmortizationModal extends React.PureComponent {
	getTotalAmountFinanced() {
		let val;
		try {
			let schedule_data = this.props.data.estimates
				.find((e) => e.id == this.props.specOptionId)
				?.attributes.find((a) => a.id == this.props.lineId)?.schedule;
			val = schedule_data[0].balance + schedule_data[0].principal;
		} catch (e) {
			val = this.props.data?.project_lead?.amount;
		}

		return formatters.USDCurrency.formatter(val);
	}

	downloadCSV = () => {
		let scheduleData = this.props.data.estimates
			.find((e) => e.id == this.props.specOptionId)
			?.attributes.find((a) => a.id == this.props.lineId)?.schedule;

		if (!scheduleData) return;

		// Create CSV headers
		const headers = [
			'Year',
			'Payment #',
			'Payment',
			'Principal',
			'Interest',
			'Balance',
		];

		// Prepare data for CSV (without HTML formatting)
		const csvData = scheduleData.map((row) => [
			row.year || '',
			row.number || '',
			row.payment || 0,
			row.principal || 0,
			row.interest || 0,
			row.balance || 0,
		]);

		// Add total row
		const totalPayment = scheduleData.reduce(
			(acc, curr) => acc + (curr.payment || 0),
			0
		);
		const totalPrincipal = scheduleData.reduce(
			(acc, curr) => acc + (curr.principal || 0),
			0
		);
		const totalInterest = scheduleData.reduce(
			(acc, curr) => acc + (curr.interest || 0),
			0
		);

		csvData.push([
			'',
			'Total',
			totalPayment,
			totalPrincipal,
			totalInterest,
			'',
		]);

		// Convert to CSV string
		const csvContent = [
			headers.join(','),
			...csvData.map((row) => row.join(',')),
		].join('\n');

		// Create and download file
		const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
		const link = document.createElement('a');
		const url = URL.createObjectURL(blob);
		link.setAttribute('href', url);
		link.setAttribute(
			'download',
			`amortization_schedule_${new Date().toISOString().split('T')[0]}.csv`
		);
		link.style.visibility = 'hidden';
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	};

	prepareScheduleData() {
		let scheduleData = this.props.data.estimates
			.find((e) => e.id == this.props.specOptionId)
			?.attributes.find((a) => a.id == this.props.lineId)?.schedule;

		if (!scheduleData) return [];

		// Create a copy of the data to avoid mutating the original
		let formattedData = scheduleData.map((d) => ({
			...d,
			balance: formatters.USDCurrency.formatter(d.balance),
			interest: formatters.USDCurrency.formatter(d.interest),
			principal: formatters.USDCurrency.formatter(d.principal),
			payment: formatters.USDCurrency.formatter(d.payment),
		}));

		// Add total row
		formattedData.push({
			number: <span className="has-text-weight-semibold">Total</span>,
			_html_payment: (
				<span className="has-text-weight-semibold">
					{formatters.USDCurrency.formatter(
						scheduleData.reduce((acc, curr) => +acc + curr.payment, 0)
					)}
				</span>
			),
			_html_principal: (
				<span className="has-text-weight-semibold">
					{formatters.USDCurrency.formatter(
						scheduleData.reduce((acc, curr) => +acc + curr.principal, 0)
					)}
				</span>
			),
			_html_interest: (
				<span className="has-text-weight-semibold">
					{formatters.USDCurrency.formatter(
						scheduleData.reduce((acc, curr) => +acc + curr.interest, 0)
					)}
				</span>
			),
			_html_balance: <span>--</span>,
		});

		return formattedData;
	}

	render() {
		const scheduleData = this.prepareScheduleData();

		return (
			<div className={`modal ${this.props.visible ? 'is-active' : ''}`}>
				<div className="modal-background" />
				<div
					className="modal-card"
					style={this.props.cardStyle ? this.props.cardStyle : {}}
				>
					<header
						className="modal-card-head"
						style={{
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center',
							width: '100%',
							margin: 0,
							padding: '1rem',
							backgroundColor: '#294d85',
						}}
					>
						<h5
							className="title is-5 has-text-white-bis"
							style={{
								margin: 0,
								display: 'flex',
								alignItems: 'center',
							}}
						>
							{this.props.title || 'Amortization'}
						</h5>
						<button className="button is-link" onClick={this.downloadCSV}>
							<span className="icon is-small">
								<i className="fas fa-download" />
							</span>
							<span>Download CSV</span>
						</button>
					</header>
					<div className="modal-card-body">
						<div className="my-3">
							<p>
								Total Amount Financed:
								<span className="has-text-weight-semibold">
									{' '}
									{this.getTotalAmountFinanced()}
								</span>
							</p>
							<p className="has-text-grey is-size-7">
								Initial balance may be higher than this amount due to
								capitalized interest and fees.
							</p>
						</div>
						<div className="table-wrapper is-flex is-justify-content-center">
							<BaseTable
								data={scheduleData}
								columns={[
									'year',
									'number',
									'payment',
									'principal',
									'interest',
									'balance',
								]}
								sortable={false}
								rowStyle="has-text-info"
							/>
						</div>
						{this.props.children}
					</div>
					{this.props.onClose && (
						<button
							className="modal-close is-large"
							style={{ float: 'right' }}
							aria-label="close"
							onClick={this.props.onClose}
						/>
					)}
				</div>
			</div>
		);
	}
}
